import { clsx } from "clsx"
import { lazy, Suspense, useEffect, useState } from "react"

import dmeet from "@/assets/lottie/dmeet.json"
import { useSplashScreen } from "@/components/SplashScreen/useSplashScreen"

const Lottie = lazy(() => import("lottie-react"))

import styles from "./SplashScreen.module.scss"

const FADE_OUT_MS = 300

const SplashScreen = () => {
  const { isVisible } = useSplashScreen()
  const [mounted, setMounted] = useState(true)

  useEffect(() => {
    if (!isVisible) {
      const timer = setTimeout(() => setMounted(false), FADE_OUT_MS)
      return () => clearTimeout(timer)
    }
  }, [isVisible])

  if (!mounted) return null

  return (
    <div className={clsx(styles.splashScreen, !isVisible && styles.fadeOut)}>
      <div className={styles.logoContainer}>
        <Suspense fallback={null}>
          <Lottie animationData={dmeet} autoplay loop={false} />
        </Suspense>
      </div>
    </div>
  )
}

export default SplashScreen
